import { camelCase, snakeCase } from '@ridi/object-case-converter/dist/index';
import { extendObservable } from 'mobx';
import FeedbackParticipant from '../models/FeedbackParticipant';
import axios from '../../../libs/axios_csrf';

export default class FeedbackParticipantsStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    extendObservable(this, {
      feedbackParticipants: [],
    });
  }

  createFeedbackParticipant(feedbackChain, participant, jsonAttributes) {
    const feedbackParticipant = new FeedbackParticipant(-1, feedbackChain, this, false, participant, jsonAttributes);
    feedbackChain.feedbackParticipants.push(feedbackParticipant);
    this.createBackend(feedbackParticipant);
  }

  loadFromJsonArray(array, feedbackChain) {
    const result = [];
    array.forEach((el) => {
      const feedbackParticipant = FeedbackParticipant.deserialize(el, feedbackChain, this);
      this.feedbackParticipants.push(feedbackParticipant);
      result.push(feedbackParticipant);
    });
    return result;
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BACKEND CONNECTIONS
  createBackend(feedbackParticipant) {
    axios.post('/feedback_participants.json', {
      feedback_chain_id: feedbackParticipant.feedbackChain.id,
      user_id: feedbackParticipant.participant.id,
      feedback_participant: snakeCase(feedbackParticipant.toJson()),
    }).then((response) => {
      feedbackParticipant.updateFromJson(camelCase(response.data.feedback_participant));
      feedbackParticipant.persisted = true;
    })
      .catch((error) => {
        console.log(error);
      });
  }

  updateBackend(feedbackParticipant) {
    axios.patch(`/feedback_participants/${feedbackParticipant.id}.json`, {
      feedback_participant: snakeCase(feedbackParticipant.toJson()),
    }).then((response) => {
      feedbackParticipant.updateFromJson(camelCase(response.data.feedback_participant));
    }).catch((errors) => {
    });
  }

  destroyBackend(participant) {
  }
  // end BACKEND CONNECTIONS
  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
